export type PublishHistoryRowLike = {
  correlationId?: unknown
}

export function filterPublishHistoryRowsByCorrelationId<T extends PublishHistoryRowLike>(
  rows: T[],
  term: string,
): T[] {
  const q = String(term || '').trim().toLowerCase()
  if (!q) return rows

  return (rows || []).filter((r) => String(r?.correlationId ?? '').toLowerCase().includes(q))
}

